export default "/_next/static/images/4c705d3a9bbb680692387475eacf9625.png";